import { render, staticRenderFns } from "./PhysicalPackagesEdit.vue?vue&type=template&id=29af6058&scoped=true"
import script from "./PhysicalPackagesEdit.vue?vue&type=script&lang=js"
export * from "./PhysicalPackagesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29af6058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29af6058')) {
      api.createRecord('29af6058', component.options)
    } else {
      api.reload('29af6058', component.options)
    }
    module.hot.accept("./PhysicalPackagesEdit.vue?vue&type=template&id=29af6058&scoped=true", function () {
      api.rerender('29af6058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/physicalPackages/PhysicalPackagesEdit.vue"
export default component.exports